import { useGetBusinessUserMeQuery } from '@/pages/Business/pages/Users/services';
import { EXCLUDED_EXTERNAL_OPERATOR_ID } from '@/components/security/AppRoles';

const useIsExcludedExternalOperatorScope = () => {
  const { data: businessUserMe, isLoading } = useGetBusinessUserMeQuery();

  const isExcludedOperatorScope = Boolean(
    businessUserMe?.scopes?.logisticOperator?.include?.includes(
      EXCLUDED_EXTERNAL_OPERATOR_ID
    )
  );

  return { isExcludedOperatorScope, isLoading };
};

export default useIsExcludedExternalOperatorScope;
